import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { impersonationClaims, restoreAdminSession } from "@/lib/supportMode";

/* Fase 10 — banner persistente y visible mientras un admin actúa como otro
 * usuario. "Salir" cierra la impersonación (auditada) y restaura la sesión admin. */
export const SupportModeBanner = () => {
  const { t } = useTranslation();
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const claims = impersonationClaims();

  if (!claims || !user) return null;

  const exit = async () => {
    try {
      await api.post("/admin/impersonation/end");
    } catch {
      // la sesión admin se restaura igualmente
    }
    restoreAdminSession();
    await refreshUser();
    toast(t("admin.supportEnded"));
    navigate("/admin/users");
  };

  return (
    <div
      data-testid="support-mode-banner"
      role="status"
      className="fixed bottom-5 inset-x-0 z-[100] flex justify-center px-4 pointer-events-none"
    >
      <div className="pointer-events-auto flex items-center gap-3 rounded-full bg-[#0A0A0A] text-white pl-4 pr-2 py-2 shadow-2xl shadow-black/25">
        <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#2E7D5B] opacity-60" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#1D4D3B]" />
        </span>
        <p className="text-xs font-medium truncate max-w-[55vw] sm:max-w-none">
          {t("admin.supportBanner", { name: user.name || user.email })}
        </p>
        <button
          type="button"
          onClick={exit}
          data-testid="support-mode-exit"
          className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#0A0A0A] text-xs font-semibold px-3.5 py-1.5 hover:bg-white/85 transition-colors duration-200"
        >
          <LogOut className="w-3 h-3" aria-hidden="true" />
          {t("admin.supportExit")}
        </button>
      </div>
    </div>
  );
};
